import { useContext } from 'react';
import type { useGetRoleAccess } from 'src/hooks/queries/role-access/useGetRoleAccess';

import { PermissionsContext } from './PermissionsContext';

type GetRoleAccessData = {
  role_access: NonNullable<ReturnType<typeof useGetRoleAccess>['roleAccess']>;
};

type RoleAccess = GetRoleAccessData['role_access'][number];

export function useRoleAccess(): RoleAccess[] {
  const context = useContext(PermissionsContext)!;
  if (context === null) {
    throw new Error('useRoleAccess must be used within PermissionsProvider');
  }

  return context;
}
